// extracted by mini-css-extract-plugin
module.exports = {"logo":"_331c254","pulse":"_5dce895"};